import { axios } from '@/services/axios';

const getEngines = async (currentScope) => {
    const res = await axios.get('/engines', {
        headers: { 'X-RequestScope': currentScope },
    });
    return res.data;
};

export default getEngines;
